import * as React from 'react';
import * as _ from 'lodash';
import SelectionDialog, {SelectionDialogProps} from '../../cl-dialogs/SelectionDialog/index';
import {Omit} from '@material-ui/core';
import {addDynamicDialog} from '../../../crazyEditor/redux/modules/panel/panel';
import {ColumnsInfo, RowDataType, TableState} from 'cl-table/redux/actions';
import {SelectionDialogItemProps} from 'cl-dialogs/SelectionDialog/SelectionDialogItem';
import {getColumnDisplayName, getValidateValue} from 'cl-table/VirtualizedHelpers';
import DefaultEditDialog from 'cl-table/DefaultEditDialog';
import {TableContext} from 'cl-table/redux/createTableContext';
import {connect} from 'react-redux';
import {TableContextProps, TableStateProps} from './BulkEditButton';
import {stringToDashed} from 'cl-automation-utils';

interface BulkEditDialogProps<RowData extends RowDataType>
  extends Omit<SelectionDialogProps, 'title' | 'items' | 'actions'> {
  addDynamicDialog: typeof addDynamicDialog;
}

class BulkEditDialog<RowData extends RowDataType> extends React.PureComponent<
  BulkEditDialogProps<RowData> & Pick<TableContext, TableContextProps> & Pick<TableState<RowData>, TableStateProps>,
  {items: SelectionDialogItemProps[]}
> {
  state = {
    items: null,
  };

  async componentDidMount() {
    this.setState({items: await Promise.resolve(this.buildListItemsFromProducts())});
  }

  buildListItemsFromProducts = async () =>
    _.map<ColumnsInfo, SelectionDialogItemProps>(
      _.omit(this.props.columns, 'SKU'),
      (columnData, columnName): SelectionDialogItemProps => {
        const displayName = getColumnDisplayName(columnName, columnData);
        return {
          id: `cla-list-item-${stringToDashed(displayName)}`,
          label: displayName,
          onClick: this.handleItemClicked(columnName, columnData),
        };
      }
    );

  handleItemClicked = (columnName, columnData) => () => {
    const {columns, addDynamicDialog, onClose} = this.props;
    addDynamicDialog(DefaultEditDialog, {
      name: getColumnDisplayName(columnName, columnData),
      ..._.pick(columns[columnName], ['type', 'options', 'creatable']),
      validate: getValidateValue(undefined, columnName, columnData),
      onChange: (value, operator, props) => this.onChange(value, operator, props, columnName),
    });
    onClose(null);
  };

  onChange = async (value, operator, props, columnName) => {
    const {selection, onClose, onChange} = this.props;
    onChange(selection, columnName, value);
    if (props.onClose) {
      props.onClose(null);
    }
    onClose(null);
  };

  render() {
    const {addDynamicDialog, onChange, ...props} = this.props;
    const {items} = this.state;
    return <SelectionDialog searchable items={items} title="Choose attribute to edit:" {...props} />;
  }
}

export default connect(
  null,
  {addDynamicDialog}
)(BulkEditDialog);
